import { Grid } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from '../../../components/Form/Select'
import TextField from '../../../components/Form/TextField'
import LoadingUI from '../../../components/ui/LoadingUI'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import utilsDate from '../../../utils/Date'
import { useStyles } from '../Style'

type props1 = {
    control: any,
    onChange: (e: any) => void, setValue: any, mvmStatus?: any, queryMvmId?: any, showSearch?: any, name: any, showAutoComplete?: any, screen?: string, showDriverData?: boolean,
    includeProperties: string[]
};

const MvmSummary: React.FC<props1> = ({ control, onChange, setValue, mvmStatus, queryMvmId, showSearch = false, showAutoComplete = true, screen = '', showDriverData = false, includeProperties }) => {
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const [loading, setLoading] = useState(false)
    const [reloading, setReLoading] = useState(false)
    const [mvmFound, setMvmFound] = useState<boolean>(false)
    const { enqueueSnackbar } = useSnackbar()
    const { user } = useAuth()
    const [autoComplete, setAutoComplete] = useState(showAutoComplete);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (queryMvmId)
            searchById(queryMvmId)
        else
            setMvmFound(false);

        setReLoading(true);
    }, [queryMvmId])

    function search(data: any) {
        if (data !== "") {
            setLoading(true)
            setMvmFound(false)
            onChange(null)

            MvmApi.getMvmByMvmNumber(data, user.company.plantID, includeProperties)
                .then(result => {


                    if (result && mvmStatus && !mvmStatus.includes(result.status)) {
                        setMvmFound(false)
                        enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
                    }
                    else if (result) {

                        setValue("queryMvmNumber", result.mvmNumber)
                        setValue("shippingSupplier", result.shippingSupplierId + " - " + result.shippingSupplierCorporateName)
                        setValue("mvmType", result.mvmJIS)
                        setValue("submitDate", utilsDate.DateTimeShort(result.submitDate) || '')
                        setValue("entranceDate", utilsDate.DateTimeShort(result.entranceDate) || '')
                        setValue("vehiclePlateNumber", result.vehiclePlateNumber || '')
                        setValue("vehicleTypeDescription", result.vehicleTypeDescription || '')
                        setValue("driverName", result.driverName || '')
                        setValue('driverRGNumber', result.driverRGNumber || '')
                        setValue('driverCPFNumber', result.driverCPFNumber || '')
                        setValue('driverCNHType', result.driverCNHType || '')
                        setValue('driverCNHNumber', result.driverCNHNumber || '')
                        setValue('driverCNHExpirationDate', utilsDate.DateShort(result.driverCNHExpirationDate) || '')
                        setValue("helperQuantity", result.helperQuantity)
                        setValue("cTeNumber", result.cTeNumber || '')
                        setValue("shippingCompanySupplier", result.shippingCompanySupplierId + " - " + result.shippingCompanySupplierCorporateName)

                        setMvmFound(true)
                        onChange(result)

                    } else {
                        setMvmFound(false)
                        enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
                    }
                }).catch(() => {
                }).finally(() => {
                    setLoading(false);
                })
        }
    }

    function searchById(data: any) {
        if (data !== "") {
            setLoading(true)
            onChange(null)
            setMvmFound(false)

            MvmApi.getMvm(data, screen, includeProperties)
                .then(result => {

                    if (result && mvmStatus && !mvmStatus.includes(result.status)) {
                        setMvmFound(false)
                        enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
                    }
                    else if (result) {
                        setValue("queryMvmNumber", result.mvmNumber)
                        setAutoComplete(false);
                        setValue("shippingSupplier", result.shippingSupplierId + " - " + result.shippingSupplierCorporateName)
                        setValue("mvmType", result.mvmJIS)
                        setValue("submitDate", utilsDate.DateTimeShort(result.submitDate) || '')
                        setValue("entranceDate", utilsDate.DateTimeShort(result.entranceDate) || '')
                        setValue("vehiclePlateNumber", result.vehiclePlateNumber || '')
                        setValue("vehicleTypeDescription", result.vehicleTypeDescription || '')
                        setValue("driverName", result.driverName || '')
                        setValue("helperQuantity", result.helperQuantity)
                        setValue("cTeNumber", result.cTeNumber || '')
                        setValue("shippingCompanySupplier", result.shippingCompanySupplierId + " - " + result.shippingCompanySupplierCorporateName)

                        setMvmFound(true)
                        onChange(result)

                    } else {
                        setMvmFound(false)
                        enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
                    }
                }).catch(() => {
                }).finally(() => {
                    setLoading(false);
                })
        }
    }

    if (!reloading) {
        return <></>;
    } else
        return (
            <>

                <Grid container spacing={1} >
                    <Grid item xs={2}>
                        {autoComplete ? (
                            <Select
                                label={t('mvmNumber')}
                                name={'mvmNumber'}
                                control={control}
                                autoFocus={true}
                                searchFunction={
                                    (mvmNumber: string) => {
                                    if (!mvmNumber || mvmNumber.length !== 8) {
                                        return Promise.resolve([])
                                    }
                                    return MvmApi.searchMvmNumbersNonCountAutocomplete(user.company.companyID, mvmNumber,mvmStatus)
                                }}
                                onChange={(e: any) => search(e.label)}
                                style={{ width: "100%", marginRight: 10 }}
                                allowEnterKey={false} />

                        ) : (<TextField
                            label={t('mvmNumber')}
                            name='queryMvmNumber'
                            control={control}
                            autoFocus={true}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    search((event.target as HTMLInputElement).value)
                                    event.preventDefault();
                                }
                            }}
                            style={{ width: "100%", marginRight: 10 }}
                            inputProps={{
                                minLength: 8,
                            }}
                            InputProps={{
                                readOnly: queryMvmId && queryMvmId > 0,
                                autoFocus: true,
                                classes: {
                                    input: (queryMvmId && queryMvmId > 0 ? classes.inputBlocked : '')
                                }
                            }} />)
                        }

                    </Grid>
                    {loading || !mvmFound ? <></> :
                        <>
                            <Grid item xs={8}>
                                <TextField
                                    label={t("shippingSupplier")}
                                    name="shippingSupplier"
                                    control={control}
                                    fullWidth
                                    autoFocus={true}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        autoFocus: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label={t("mvmType")}
                                    name="mvmType"
                                    control={control}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                        </>
                    }
                </Grid>
                {loading ? <LoadingUI /> : !mvmFound ? <></> :
                    <>
                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <TextField
                                    label={t("submitDate")}
                                    name="submitDate"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label={t("entranceDate")}
                                    name="entranceDate"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    label={t("vehiclePlateNumber")}
                                    name="vehiclePlateNumber"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField
                                    label={t("vehicleTypeDescription")}
                                    name="vehicleTypeDescription"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField
                                    label={t("driverName")}
                                    name="driverName"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField
                                    label={t("helperQuantity")}
                                    name="helperQuantity"
                                    control={control}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                        </Grid>

                        {showDriverData &&
                            <Grid container spacing={1}>

                                <Grid item xs={2}>
                                    <TextField
                                        label={t("driverRGNumber")}
                                        name="driverRGNumber"
                                        control={control}
                                        type="number"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: false,
                                            classes: {
                                                input: classes.inputBlocked
                                            }
                                        }} />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        label={t("driverCPFNumber")}
                                        name="driverCPFNumber"
                                        control={control}
                                        type="number"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: false,
                                            classes: {
                                                input: classes.inputBlocked
                                            }
                                        }} />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        label={t("driverCNHType")}
                                        name="driverCNHType"
                                        control={control}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked
                                            }
                                        }} />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        label={t("driverCNHNumber")}
                                        name="driverCNHNumber"
                                        control={control}
                                        type="number"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: false,
                                            classes: {
                                                input: classes.inputBlocked
                                            }
                                        }} />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        label={t("driverCNHExpirationDate")}
                                        name="driverCNHExpirationDate"
                                        control={control}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked
                                            }
                                        }} />
                                </Grid>
                            </Grid>
                        }

                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <TextField
                                    label={t("cTeNumber")}
                                    name="cTeNumber"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label={t("shippingCompanySupplier")}
                                    name="shippingCompanySupplier"
                                    control={control}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                        classes: {
                                            input: classes.inputBlocked
                                        }
                                    }} />
                            </Grid>
                        </Grid>
                    </>
                }
            </>
        )
}

export default MvmSummary

